// Catálogo pt-BR → es, estilo gettext: a CHAVE é o texto em português exatamente
// como está no código (label, primaryText, title, choices, notify, translate('...'))
// ou como o backend devolve em `message`. Sem entrada aqui → a tela mostra o português.
//
// Pra achar o que falta:
//   - `yarn i18n:extract` → scripts/i18n/out/missing-es.json (textos do código)
//   - `pxI18nMissing()` no console com o painel em espanhol (textos vistos, backend incluso)
//
// Placeholders %{...} precisam ser iguais nos dois lados.
const catalog: Record<string, string> = {
    // Login (src/resources/login/index.tsx)
    'Área de acesso': 'Área de acceso',
    'Defina uma nova senha': 'Defina una nueva contraseña',
    'Alterar senha': 'Cambiar contraseña',
    'Usuário não cadastrado': 'Usuario no registrado',
    'Erro de servidor': 'Error del servidor',
    'Não foi possível realizar o login': 'No fue posible iniciar sesión',

    // Barra superior e home
    'Alterar Senha': 'Cambiar contraseña',
    'Painel Administrador': 'Panel de administración',

    // Backend: POST /employees/login (pontuax-backend src/api/employees/employees-controller.ts)
    'Funcionário não existe.': 'El usuario no existe.',
    'Rede não cadastrada.': 'Red no registrada.',
    'Senha incorreta.': 'Contraseña incorrecta.',
    'Login ou senha incorretos.': 'Usuario o contraseña incorrectos.',
    'Muitas tentativas de login. Espere alguns minutos e tente de novo.':
        'Demasiados intentos de inicio de sesión. Espere unos minutos e intente de nuevo.',
    'Email não verificado. Por favor, verifique sua caixa de entrada.':
        'Correo electrónico no verificado. Por favor, revise su bandeja de entrada.',
    'Você não possui autorização necessária': 'No tiene la autorización necesaria',

    // Backend: payload recusado pelo Joi em produção (pontuax-backend src/utils/utils.ts failAction)
    'Invalid request payload input': 'Los datos enviados no son válidos',

    // Relatório Divergência de Preço (src/resources/reports/ReportPriceDivergence.tsx): valores de
    // PATTERNS/PATTERN_MEANING ficam num objeto com chave técnica, traduzidos por __t() no render.
    // O extrator não enxerga esses literais — manter aqui à mão.
    "Concentrador truncou 1 centavo": "El concentrador truncó 1 centavo",
    "Concentrador mandou preço cheio": "El concentrador envió el precio completo",
    "Desconto não aplicado na bomba": "Descuento no aplicado en el surtidor",
    "Não classificado": "No clasificado",
    "Desconto saiu na bomba, registro errado": "El descuento salió en el surtidor, registro incorrecto",
    "Nenhuma hipótese fecha com o total": "Ninguna hipótesis cuadra con el total",

    // Valor do Desconto(%) (src/components/DiscountPercentageInput.tsx): mensagens de minValue/maxValue
    // declaradas em parâmetro default do componente, posição que o extrator não varre — manter aqui à mão.
    "Deve ser no mínimo 1%": "Debe ser como mínimo 1%",
    "Deve ser no máximo 100%": "Debe ser como máximo 100%",
    "Unificação desfeita: %{restored} abastecimentos restaurados e %{remerged} unificação(ões) refeita(s).": "Unificación deshecha: %{restored} abastecimientos restaurados y %{remerged} unificación(es) rehecha(s).",
    "Unificação desfeita: %{restored} abastecimentos restaurados.": "Unificación deshecha: %{restored} abastecimientos restaurados.",
    "Erro ao desfazer a unificação": "Error al deshacer la unificación",
    "Desfazer unificação": "Deshacer unificación",
    "Separa de volta os abastecimentos que foram juntados e refaz a unificação certa, se houver. Quantidade, valor e encerrante editados à mão neste abastecimento voltam ao que eram antes da unificação.": "Separa nuevamente los abastecimientos que fueron unidos y rehace la unificación correcta, si corresponde. Cantidad, valor y encerrante editados a mano en este abastecimiento vuelven a lo que eran antes de la unificación.",
    "Unificação desfeita (%{restored} abastecimentos restaurados), mas a unificação certa não foi refeita: %{reason}": "Unificación deshecha (%{restored} abastecimientos restaurados), pero la unificación correcta no fue rehecha: %{reason}",

    // Motivos de revogação de sessão (REVOKED_REASONS em ReportEmployeeSessions.tsx):
    // valores de objeto com chave técnica, que o extrator não varre — manter aqui à mão.
    "Saiu pelo próprio painel": "Salió desde el propio panel",
    "Revogada por um admin": "Revocada por un admin",
    "Revogada em massa por um admin": "Revocada en masa por un admin",
    "Troca de senha": "Cambio de contraseña",
    "Excedeu o limite de dispositivos": "Excedió el límite de dispositivos",
    "Substituída por um login novo no mesmo navegador": "Reemplazada por un nuevo inicio de sesión en el mismo navegador",

    // Editor da Home (HomeItemsInput): valores de objeto-constante (SPAN_LABEL, METHODS,
    // SECTION_CONTENT_HINT) que o extrator não varre — traduzidos com __t() no ponto de
    // renderização e cadastrados aqui à mão.
    "Linha inteira": "Fila completa",
    "Meia linha": "Media fila",
    "Tela do app": "Pantalla de la app",
    "Site externo": "Sitio externo",
    "As imagens ficam em \"Imagens do carrossel\", logo abaixo.": "Las imágenes están en \"Imágenes del carrusel\", justo abajo.",

    // Editor da Home — rótulos de layout de linha (ROW_LAYOUT_LABEL / _DESCRIPTION):
    // valores de objeto-constante que o extrator não varre, traduzidos com __t() no
    // ponto de renderização.
    "Uma imagem": "Una imagen",
    "Duas lado a lado": "Dos lado a lado",
    "Duas imagens dividindo a mesma linha.": "Dos imágenes compartiendo la misma fila.",

    // Mockup da Home (appArt/components/homeSections): rótulos das ILUSTRAÇÕES de
    // exemplo, que vivem em constante e são traduzidos com __t() na renderização —
    // o extrator não varre valor de constante. Os demais já estão em outros lotes.
    "Alimentos": "Alimentos",
    "Lava-jato": "Lavadero",
    "Posto Centro": "Estación Centro",
    "Posto Marginal": "Estación Marginal",
    "Posto Litoral": "Estación Litoral",
    "Gasolina comum": "Gasolina común",
    "Etanol": "Etanol",
    "Whatsapp": "Whatsapp",

    // Destino do toque dos blocos e cards da Home (HomeItemsInput/homeItems.ts):
    // grupo e tela vivem em constante de módulo e são traduzidos com __t() na
    // renderização — o extrator não varre valor de constante.
    'Nenhum — imagem não clicável': 'Ninguno — imagen no clicable',
    'Preencha o destino do toque ou deixe o bloco sem ação.': 'Complete el destino del toque o deje el bloque sin acción.',
    'Cupons e descontos': 'Cupones y descuentos',
    'Resgates e brindes': 'Canjes y regalos',
    'Promoções e sorteios': 'Promociones y sorteos',
    'Indicação e divulgação': 'Recomendación y difusión',
    'Abastecimento': 'Carga de combustible',
    'Conta e pontos': 'Cuenta y puntos',
    'Regras': 'Reglas',
    'Cupons e ofertas': 'Cupones y ofertas',
    'Meus cupons': 'Mis cupones',
    'Meus descontos': 'Mis descuentos',
    'Descontos Dotz': 'Descuentos Dotz',
    'Resgatar produtos': 'Canjear productos',
    'Clube de vantagens': 'Club de ventajas',
    'Minhas conquistas': 'Mis logros',
    'Roleta da Sorte': 'Ruleta de la Suerte',
    'Sorteios': 'Sorteos',
    'Número da sorte': 'Número de la suerte',
    'Bolões': 'Quinielas',
    'Indique e ganhe': 'Recomienda y gana',
    'Promoter': 'Promoter',
    'Resgatar código de divulgação': 'Canjear código de difusión',
    'Abastecer': 'Cargar combustible',
    'Postos': 'Estaciones',
    'Histórico de abastecimentos': 'Historial de cargas',
    'Posto favorito': 'Estación favorita',
    'Extrato': 'Extracto',
    'Detalhes da conta': 'Detalles de la cuenta',
    'Notificações': 'Notificaciones',
    'Perfil': 'Perfil',
    'Meus veículos': 'Mis vehículos',
    'Regulamento': 'Reglamento',
    'Termos de uso': 'Términos de uso',

    // Item específico do destino do toque (`target` em HomeItemsInput/homeItems.ts).
    // Valor de constante: o extrator não enxerga, entra à mão como o bloco acima.
    'Roleta': 'Ruleta',
    'Todas — abre a lista de roletas': 'Todas — abre la lista de ruletas',
    'Sorteio': 'Sorteo',
    'Todos — abre a lista de sorteios': 'Todos — abre la lista de sorteos',
    'Bolão': 'Quiniela',
    'Todos — abre a lista de bolões': 'Todos — abre la lista de quinielas',
    'Posto': 'Estación',
    'Todos — abre a lista de postos': 'Todos — abre la lista de estaciones',
    'item não encontrado': 'elemento no encontrado',
    'Escolhido um item, o toque abre direto nele em vez da lista.':
        'Si elige un elemento, el toque lo abre directamente en lugar de la lista.',

    // Segmentação por etiqueta do bloco de imagem da Home (BannerFormDialog).
    'Exibir apenas para as etiquetas':
        'Mostrar solo para las etiquetas',
    'Sem etiqueta selecionada, o bloco aparece para todos os clientes. Com mais de uma, basta o cliente ter qualquer uma delas.':
        'Sin etiqueta seleccionada, el bloque aparece para todos los clientes. Con más de una, basta con que el cliente tenga cualquiera de ellas.',

    // Mensagens do backend que o cadastro e a lista de descontos v2 mostram (Boom de
    // pontuax-backend src/api/discounts/discounts-controller.ts, discounts-validator.ts e
    // src/api/cities/cities-controller.ts). O extrator não enxerga texto vindo da API.
    'Acesso negado': 'Acceso denegado',
    'Informe a rede': 'Indique la red',
    'Informe o desconto': 'Indique el descuento',
    'Desconto não encontrado': 'Descuento no encontrado',
    'Desconto não encontrado!': '¡Descuento no encontrado!',
    'Cidade não encontrado!': '¡Ciudad no encontrada!',
    'Mensagem não encontrada.': 'Mensaje no encontrado.',
    'Rede de postos não encontrada!': '¡Red de estaciones no encontrada!',
    // Boom do createGift (pontuax-backend src/api/gifts/gifts-controller.ts, partnerOnFillinRule)
    'Regra de abastecimento só vale em posto. Loja e parceiro não têm bomba: troque pelo posto na regra e escolha a loja em Locais de Resgate.':
        'La regla de carga de combustible solo vale en estación. Tienda y socio no tienen surtidor: cambie por la estación en la regla y elija la tienda en Lugares de Canje.',
    'Usuário autenticado não corresponde a rede informada': 'El usuario autenticado no corresponde a la red indicada',
    'Usuário autenticado não corresponde à rede informada': 'El usuario autenticado no corresponde a la red indicada',
    'Data final não pode ser inferior a data inicial': 'La fecha final no puede ser anterior a la fecha inicial',
    'Desconto de recuperação exige custo em pontos e valor em R$ por litro (desconto) em todos os combustíveis.':
        'El descuento de recuperación exige costo en puntos y valor en R$ por litro (descuento) en todos los combustibles.',
    'Desconto de recuperação não pode ter clientes, grupos ou etiquetas: o cupom só é atribuído pelo motor da campanha.':
        'El descuento de recuperación no puede tener clientes, grupos ni etiquetas: el cupón solo lo asigna el motor de la campaña.',

    // Detalhe da recompensa em dinheiro na lista de recompensas do brinde (ProductList).
    // Frase montada em função, fora de JSX: o extrator não a vê.
    'Vale %{value} — resgatável em qualquer local que aceite cashback':
        'Vale %{value} — se puede canjear en cualquier local que acepte cashback',

    // Quadro "Informações técnicas" do detalhe do abastecimento (FillinShow).
    'Marca da automação': 'Marca de la automatización',
    'Versão da automação': 'Versión de la automatización',
    'A automação vem da última leitura diária do concentrador, não do instante do abastecimento.':
        'La automatización proviene de la última lectura diaria del concentrador, no del momento de la carga de combustible.',

    // Aviso e alerta do upload de imagem (components/ImageInformations, ImageUploadInput).
    'A imagem deve ter o tamanho máximo de %{size}MB. Os formatos aceitos são .jpeg e .png.':
        'La imagen debe tener un tamaño máximo de %{size}MB. Los formatos aceptados son .jpeg y .png.',
    'A imagem passa do limite de %{size}MB. Reduza o arquivo e tente novamente.':
        'La imagen supera el límite de %{size}MB. Reduzca el archivo e inténtelo de nuevo.',
    'Formato de arquivo não aceito. Envie uma imagem .jpeg, .png, .gif ou .webp.':
        'Formato de archivo no aceptado. Envíe una imagen .jpeg, .png, .gif o .webp.',

    // REWARD_STATUS_LABELS da aba Clientes da campanha de recuperação
    // (customerRecoveryRules/components/labels.ts): valores de constante de módulo, que o
    // extrator não lê. A tradução acontece no ponto de renderização, com __t(MAPA[chave]).
    'Ainda não': 'Todavía no',
    'Conquistou': 'Lo consiguió',
    'Trocou o cupom': 'Canjeó el cupón',
    'Não conquistou': 'No lo consiguió',

    // REWARD_TYPE_LABEL do editor de brinde da campanha de recuperação
    // (resources/customerRecoveryRules/components/LevelRewardEditor.tsx): constante de módulo
    // com chave técnica, que o extrator não enxerga. 'Número da sorte' já está acima.
    'Produto virtual': 'Producto virtual',
    'Produto do catálogo': 'Producto del catálogo',
    'Desconto no abastecimento': 'Descuento en la carga de combustible',

    // Resumo do nível fechado no passo Níveis, quando o brinde ainda não tem recompensa
    // escolhida (LevelsStep.tsx). Entrou no lugar de 'sem título', que saiu com o campo.
    'sem recompensa': 'sin recompensa',

    // Trava dos locais de troca enquanto não há produto escolhido (LevelRewardEditor.tsx).
    'Escolha o produto do catálogo primeiro: é dele que vem o valor de cada local.':
        'Elige primero el producto del catálogo: de él viene el valor de cada lugar.',

    // Opções do filtro "Usou desconto" (discountChoices em ReportFillins.jsx e
    // ReportFillinByAttendant.jsx): valor de constante, que o extrator não enxerga.
    'Com Desconto': 'Con descuento',
    'Sem Desconto': 'Sin descuento',

    // Backend: GET /reports/deliveries com posto sem concentrador cadastrado
    // (pontuax-backend src/api/delivery-report/delivery-report-controller.ts, STATION_WITHOUT_CONCENTRATOR).
    'Nenhum dos postos selecionados tem concentrador cadastrado. Cadastre o concentrador no posto para ver as entregas.':
        'Ninguna de las estaciones seleccionadas tiene concentrador registrado. Registre el concentrador en la estación para ver las entregas.',

    // Formas de plural da importação de CPFs (helper `plural` em resources/tag/ImportCpfsDialog.tsx):
    // literal passado como argumento, que o extrator não enxerga.
    'pré-cadastro novo': 'prerregistro nuevo',
    'pré-cadastros novos': 'prerregistros nuevos',
    'entrou': 'entró',
    'entraram': 'entraron',
    'removido': 'quitado',
    'removidos': 'quitados',
    'cliente já cadastrado entra': 'cliente ya registrado entra',
    'clientes já cadastrados entram': 'clientes ya registrados entran',
    'já estava na etiqueta': 'ya estaba en la etiqueta',
    'já estavam na etiqueta': 'ya estaban en la etiqueta',
    'linha ignorada': 'fila ignorada',
    'linhas ignoradas': 'filas ignoradas',
    'pessoa que não está': 'persona que no está',
    'pessoas que não estão': 'personas que no están',

    // Backend: POST /chains/{chainId}/tag/{id}/import-cpfs sem "Cadastrar cliente" nem "Importar CPFs na etiqueta"
    // (pontuax-backend src/api/tag/tag-controller.ts, canImportCpfs).
    'Sem permissão para importar CPFs na etiqueta': 'Sin permiso para importar CPFs en la etiqueta',
};

export default catalog;
